import { createSelector } from 'reselect';
import { AppState } from '../store';
import { BuilderSettingsState } from '../types/builders';

export const selectBuilderState = (state: AppState) => state.builder;
export const selectSettings = (state: BuilderSettingsState) => state.settings;

export const selectBuilderSettings = createSelector(selectBuilderState, selectSettings);
